import React from 'react';
import ReactDOM from 'react-dom/client';
import { ClerkProvider } from '@clerk/clerk-react';
import { RouterProvider } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { router } from './routes';
import { useApiToken } from './hooks/use-api-token';
import './app.css';
import './stores/theme-store'; // Initialize theme on load

const CLERK_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

if (!CLERK_KEY) {
  throw new Error('VITE_CLERK_PUBLISHABLE_KEY environment variable is required');
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1
    }
  }
});

function AppWithToken() {
  useApiToken();
  return <RouterProvider router={router} />;
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <ClerkProvider
      publishableKey={CLERK_KEY}
      appearance={{
        variables: {
          colorBackground: 'hsl(var(--card))',
          colorText: 'hsl(var(--card-foreground))',
          colorTextSecondary: 'hsl(var(--muted-foreground))',
          colorInputBackground: 'hsl(var(--secondary))',
          colorInputText: 'hsl(var(--foreground))',
          colorPrimary: 'hsl(var(--primary))',
          colorNeutral: 'hsl(var(--foreground))'
        },
        elements: {
          card: 'bg-card text-card-foreground shadow-sm border border-border',
          navbarButton: 'text-foreground',
          navbarButtonIcon: 'text-muted-foreground',
          headerTitle: 'text-foreground',
          headerSubtitle: 'text-muted-foreground',
          profileSectionTitle: 'text-foreground',
          profileSectionContent: 'text-foreground',
          formFieldLabel: 'text-foreground',
          footerAction: 'text-muted-foreground',
          menuItem: 'text-foreground',
          menuList: 'bg-card border-border'
        }
      }}
    >
      <QueryClientProvider client={queryClient}>
        <AppWithToken />
      </QueryClientProvider>
    </ClerkProvider>
  </React.StrictMode>
);
